module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f920.c18f8f63.svg";